export const ROLES = ["employee", "contractor", "manager", "admin", "super_admin", "finance"] as const;

export type Role = (typeof ROLES)[number];

export type UserProfile = {
  id: string;
  email: string;
  name: string;
  role: Role;
  isActive: boolean;
};

export const roleLabels: Record<Role, string> = {
  employee: "Employee",
  contractor: "Contractor",
  manager: "Manager",
  admin: "Admin",
  super_admin: "Super Admin",
  finance: "Finance"
};

const roleHome: Record<Role, string> = {
  employee: "/employee",
  contractor: "/contractor",
  manager: "/manager",
  admin: "/admin",
  super_admin: "/admin",
  finance: "/finance"
};

export function normalizeRole(role: string | null | undefined): Role {
  const normalized = String(role || "employee")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");

  return ROLES.includes(normalized as Role) ? (normalized as Role) : "employee";
}

export function getRoleHome(role: Role): string {
  return roleHome[role];
}

export function canAccessRoute(role: Role, path: string): boolean {
  if (path === "/" || path === "/login" || path === "/employee") return true;
  if (path.startsWith("/contractor")) return ["contractor", "admin", "super_admin"].includes(role);
  if (path.startsWith("/manager")) return ["manager", "admin", "super_admin"].includes(role);
  if (path.startsWith("/finance")) return ["finance", "admin", "super_admin"].includes(role);
  if (path.startsWith("/admin")) return ["admin", "super_admin"].includes(role);
  return false;
}
